import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IBillingUserInfo } from './types';
import { injectIntl } from 'react-intl';
import { loadingCountry, storeBillingInfo, verifyBillingInfo } from '../BillingInformationView/actions';
import history from '../../history';
import PayPalButton from './PayPalButton';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
  intl: any;
  lastPath: string;
  brand: string;
  userInfo: IBillingUserInfo;
  updateBillingInfo: Function;
  updateErrorMapping: Function;
}

const PaymentDetailsPayPal = ({ intl, lastPath, brand, userInfo, updateBillingInfo, updateErrorMapping }: Props) => {
  const dispatch = useDispatch();
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePayPalSuccess = (token: any) => {
    try {
      let userInfoClone = { ...userInfo };
      userInfoClone.token = token.id;

      updateBillingInfo(userInfoClone);

      const errorHandler = (error: any) => {
        if (error) {
          console.error('API Error:', error);
        }

        setSubmitDisabled(false);
        setIsLoading(false);
        if (error) {
          let errorMapping = 'error.subscription.paypal.declined';
          if (error.response && error.response.data && error.response.data.error) {
            errorMapping = error.response.data.error;
          }
          updateErrorMapping(errorMapping);
          return;
        }

        // Navigate to next step on success
        if (lastPath === '/payment' || lastPath === '') {
          history.push('/payment');
        } else {
          history.push('/order-summary');
        }
      };

      if (lastPath === '/payment' || lastPath === '') {
        dispatch(storeBillingInfo(userInfoClone, errorHandler));
      } else {
        dispatch(verifyBillingInfo(userInfoClone, errorHandler));
      }
      dispatch(loadingCountry());
    } catch (error: any) {
      console.error('PayPal Success Handler Error:', error);
      setSubmitDisabled(false);
      setIsLoading(false);
      updateErrorMapping(error.message);
    }
  };

  const handlePayPalError = (error: any) => {
    setSubmitDisabled(false);
    setIsLoading(false);
    updateErrorMapping(error.message || 'PayPal payment failed');
  };

  const handlePayPalCancel = () => {
    setSubmitDisabled(false);
    setIsLoading(false);
    updateErrorMapping('PayPal payment was cancelled');
  };

  if (isLoading) {
    return <CircularProgress size={32} className={`${brand}-button-progress`} />;
  }

  return (
    <PayPalButton
      brand={brand}
      onPayPalSuccess={handlePayPalSuccess}
      onPayPalError={handlePayPalError}
      onPayPalCancel={handlePayPalCancel}
      disabled={submitDisabled}
      userInfo={userInfo}
    />
  );
};

export default injectIntl(PaymentDetailsPayPal);
